<div class="menu" *ngIf="Heading">
    <span class="menu-heading">{{ Heading }}</span>
    <span class="close" (click)="closeCaseCreation()">X</span>
</div>

<div class="container-fluid" style="">
    <ng-container *ngIf="showFirstSec">
        <div class="row">
            <div class="col-5 cust-sentiment">
                <label for="cust-sentiment">Customer Sentiment:</label>
            </div>
            <div class="col-7 input-cust">
                <input value="NA" class="" type="text" id="cust-sentiment" [(ngModel)]="Sentiment" readonly />
            </div>
        </div>

        <div class="row" *ngIf="isKeyword">
            <div class="col-4  cust-sentiment">
                <label for="key-match">Keyword Match:</label>
            </div>
            <div class="col-8 input-cust">
                <select name="page" [ngModel]="selectedKey" (ngModelChange)="onChange($event)">
                    <ng-container *ngFor="let item of filteredKeywordArray; let i = index">
                        <option [ngValue]="item.Value" [selected]="item.Value == selectedKey">
                            {{ item.Name }}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-5" style="margin: 7px 0px 7px 3px;">
                <div class="input-group">
                    <input style="border: none"
                           class="form-control search-input"
                           type="text" [(ngModel)]="searchval" placeholder="Search" />
                    <button class="search-btn" (click)="searchAndHighlight()">
                        <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
                    </button>
                     
                    <button  (click)="ClearSearch()" class="clear-btn"  >
                        <img alt="" class="clear-img" src="{{ baseHref }}/assets/images/icon-delete.svg" />
                     </button>
                    
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isTranscriptHistory">
            <div class="col-4  cust-sentiment">
                <label for="key-match">Transcript:</label>
            </div>
            <div class="col-8 input-cust">
                <select name="page" [ngModel]="TranscriptID" (ngModelChange)="onChangeTranscriptHistory($event)">
                    <ng-container *ngFor="let item of TranscriptHistoryArray; let i = index">
                        <option [ngValue]="item.Value"  [selected]="item.Value == TranscriptID">
                            {{ item.Name }}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>
       
    </ng-container>

    <div>
        <div class="row" *ngIf="lblMessage">
            <div class="input-data">
                <div class="form-group call-error-message">
                    <label for="call-error-message">Note: {{lblMessage}}</label>

                </div>
            </div>
        </div>
        <!--
    <div class="row" *ngIf="transcriptData?.CallSummary">
        <div class="input-data">
            <div class="form-group">
                <label for="call-summary">Conversation Summary:</label>
                <p class="call-summary" [innerHTML]="transcriptData.CallSummary | highlight:searchTerms">{{transcriptData?.CallSummary}}</p>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="transcriptData?.CaseNotes">
        <div class="input-data">
            <div class="form-group">
                <label for="call-summary">Case Notes:</label>
                <p class="call-summary" [innerHTML]="transcriptData?.CaseNotes | highlight:searchTerms">{{transcriptData?.CaseNotes}}</p>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="transcriptData?.IssueResolved">
        <div class="input-data">
            <div class="form-group">
                <label for="call-summary">Issue Resolved:</label>
                <p class="call-summary" [innerHTML]="transcriptData?.IssueResolved | highlight:searchTerms">{{transcriptData?.IssueResolved}}</p>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="transcriptData?.CustomerSatisfaction">
        <div class="input-data">
            <div class="form-group">
                <label for="call-summary">Customer Satisfaction:</label>
                <p class="call-summary" [innerHTML]="transcriptData?.CustomerSatisfaction | highlight:searchTerms">{{transcriptData?.CustomerSatisfaction}}</p>
            </div>
        </div>
    </div>
    -->
<div *ngIf="!lblMessage">
        <div *ngFor="let item of SummaryHeader | keyvalue" >
            <div class="row" *ngIf="transcriptData[item.key]">
                <div class="input-data">
                    <div class="form-group">
                        <label for="call-summary">{{item.value}}</label>
                        <p class="call-summary" [ngClass]="[item.key==='CaseNotes' ? 'CaseNotes' : '']"                        
                            [innerHTML]="transcriptData[item.key] | highlight:searchTerms"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <hr />
        <div class="row" *ngIf="transcriptData?.Sentences">
            <div class="input-data">
                <div class="form-group">
                    <label for="transcript">Transcript:</label>
                    <ul class="ul" #list>
                        <li style="margin : 10px;list-style: none;" *ngFor="let text of transcriptData?.Sentences;">

                            <div [ngClass]="[!text?.SpeakerRole?.indexOf('Agent') ? 'align-agent' : 'align-customer']">
                                <span [ngClass]="[!text?.SpeakerRole?.indexOf('Agent') ? 'agent-time' : 'customer-time']">{{text?.SpeakerRole}} {{text.StartTime | formatTimeForScreen}}</span>
                                <br>
                                <div [ngClass]="[!text?.SpeakerRole?.indexOf('Agent') ? 'agent-text' : 'customer-text']">
                                    <span [innerHTML]="text?.Transcript | highlight:searchTerms">{{text.Transcript}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
